import { __assign } from "tslib";
import { useCallback, useEffect, useMemo } from "react";
import { IMAGE_SIZE_SCALE } from "../constants";
import { useAuthData, DEFAULT_AUTH_DATA_VALUES, } from "../providers/AuthDataProvider";
import { useViewer } from "../providers/ViewerProvider";
import { defaultImages } from "../helpers/defaultImages";
export var useSetDefaultUrlsMedia = function () {
    var _a = useAuthData(), _b = _a.staticSourceUrl, staticSourceUrl = _b === void 0 ? DEFAULT_AUTH_DATA_VALUES.staticSourceUrl : _b, _c = _a.isSupportWebp, isSupportWebp = _c === void 0 ? DEFAULT_AUTH_DATA_VALUES.isSupportWebp : _c;
    var setViewerData = useViewer().setViewerData;
    var generateDefaultMedia = useCallback(function () {
        return Object.entries(defaultImages).reduce(function (accMedia, _a) {
            var _b;
            var name = _a[0], defaultUrl = _a[1];
            return (__assign(__assign({}, accMedia), (_b = {}, _b[name] = __assign({}, Object.values(IMAGE_SIZE_SCALE).reduce(function (accSize, size) {
                var _a;
                return (__assign(__assign({}, accSize), { urls: __assign(__assign({}, accSize === null || accSize === void 0 ? void 0 : accSize.urls), (_a = {}, _a[size] = defaultUrl === null || defaultUrl === void 0 ? void 0 : defaultUrl(staticSourceUrl, size, isSupportWebp), _a)), attributes: {}, id: "".concat(name, "_").concat(size) }));
            }, {})), _b)));
        }, {});
    }, [staticSourceUrl, isSupportWebp]);
    var defaultMedia = useMemo(generateDefaultMedia, [
        generateDefaultMedia,
    ]);
    useEffect(function () {
        setViewerData(function (prev) { return (__assign(__assign({}, prev), { defaultMedia: defaultMedia })); });
    }, [defaultMedia]);
};
